<input
  type="text"
  class="location-input"
  autocomplete="off"
  placeholder="Location"
  [(ngModel)]="model"
  [ngbTypeahead]="search"
  [resultFormatter]="formatter"
  [inputFormatter]="formatter"
  (selectItem)="onSelectItem($event)"
  (blur)="onBlur()"
  #instance="ngbTypeahead"
  #locationInput
/>
